import React from 'react'
import {
  useMainParticipant,
  useScreenShareParticipant,
  useMediaContext,
  useSelectedParticipant
} from '@gopeerproject/web-kit'

import MainParticipantInfo from './MainParticipantInfo'
import ParticipantTracks from './ParticipantTracks'

const MainParticipant = ({ minimized }) => {
  const mainParticipant = useMainParticipant()
  const { room } = useMediaContext()
  const localParticipant = room?.localParticipant
  const [selectedParticipant] = useSelectedParticipant()
  const screenShareParticipant = useScreenShareParticipant()

  const videoPriority =
    (mainParticipant === selectedParticipant ||
      mainParticipant === screenShareParticipant) &&
    mainParticipant !== localParticipant
      ? 'high'
      : null

  return (
    <MainParticipantInfo participant={mainParticipant} minimized={minimized}>
      <ParticipantTracks
        participant={mainParticipant}
        videoOnly
        enableScreenShare={mainParticipant !== localParticipant}
        videoPriority={videoPriority}
        isLocalParticipant={mainParticipant === localParticipant}
      />
    </MainParticipantInfo>
  )
}

export default MainParticipant
